export const DATE_FORMAT_WITH_TIME = `ddd, MMM Do, 'YY, hh:mm a`;
export const DATE_FORMAT = `ddd, MMM Do, 'YY`;
export const TIME_FORMAT = `hh:mm a`;